import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

type DuplicateUsersReportResponse = {
  blob: Blob;
  filename: string;
};

const findDuplicateUsersForNavica = async ({
  mlsType,
}: {
  mlsType: string;
}) => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: '/roster/qa_page/duplicate_users_report',
    responseType: 'blob',
    params: { mlsType },
  };

  try {
    const { data, headers } = await axios.request<Blob>(config);

    const contentDisposition = String(headers['content-disposition'] || '');
    const filenameMatch = contentDisposition.match(/filename=?"?([^";]+)"?/i);
    const filename = filenameMatch?.[1] || 'duplicateUserMapEnhanced.csv';

    return {
      blob: data,
      filename,
    } satisfies DuplicateUsersReportResponse;
  } catch (error) {
    const axiosError = axios.isAxiosError(error) ? error : undefined;
    const responseData = axiosError?.response?.data;

    if (axiosError?.response?.status === 404) {
      throw new Error('Invalid MLS Type');
    }

    if (responseData instanceof Blob) {
      const errorText = await responseData.text();

      try {
        const errorJson = JSON.parse(errorText) as { message?: string };
        throw new Error(errorJson.message || 'Invalid MLS Type');
      } catch {
        throw new Error('Invalid MLS Type');
      }
    }

    throw error;
  }
};

export default findDuplicateUsersForNavica;
